import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

export default function Recaptcha({ onChange }: any) {
  const captchaKey: string | undefined = process.env.REACT_APP_CAPTCHA_KEY
  return captchaKey ? (
    <ReCAPTCHA sitekey={captchaKey} onChange={onChange} />
  ) : null
}
